// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LeftOutlinedSvg from "@fishx/icons-svg/es/asn/LeftOutlined";
import FishxIcon from '../components/FishxIcon';

var LeftOutlined = function LeftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LeftOutlinedSvg
  }));
};

LeftOutlined.displayName = 'LeftOutlined';
export default React.forwardRef(LeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LeftOutlined.js
// module id = 3028
// module chunks = 0